export const BATCH_LOGS_RESET_STATE = 'BATCH_LOGS_RESET_STATE';
export const BATCH_LOGS_CURRENT_ITEM = 'BATCH_LOGS_CURRENT_ITEM';

export const BATCH_LOGS_REQUEST_LOADING = 'BATCH_LOGS_REQUEST_LOADING';
export const BATCH_LOGS_REQUEST_SUCCESS = 'BATCH_LOGS_REQUEST_SUCCESS';
export const BATCH_LOGS_REQUEST_FAILED = 'BATCH_LOGS_REQUEST_FAILED';

export const BATCH_LOGS_CURRENT_ACTION = 'BATCH_LOGS_CURRENT_ACTION';
export const BATCH_LOGS_RESET_ACTION = 'BATCH_LOGS_RESET_ACTION';